module.exports = __webpack_public_path__ + "img/verified-by-visa.6e963e1b.jpg";